<template>
  <div class="content">
    <!-- 面包屑 -->
    <div class="w_breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <i class="iconfont icondqwz"></i>
        <el-breadcrumb-item
          :to="{ path: '/systemConfiguration/allSystemConfiguration/device/allDevice/device/acquisitionGate' }"
        >采集网关</el-breadcrumb-item>
        <el-breadcrumb-item>RTU列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="RTU">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> RTU列表
        </span>
        <div class="w_normalNav">
          <button class="GreenSmBtn" @click="toAddNew">新增</button>
        </div>
        <section class="easyTable" ref="easyTable">
          <el-table
            :data="tableData"
            class="stripeTable"
            style="width: 100%"
            v-loading="bLoading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column
              align="center"
              v-for="i of config"
              :key="i.prop"
              :label="i.label"
              :prop="i.prop"
            ></el-table-column>
            <el-table-column label="操作" width="250" align="center">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont iconedit"
                  type="text"
                  size="small"
                  @click="toEdit(scope.$index, scope.row, true)"
                >编辑</el-link>
                <el-link
                  icon="iconfont icondelete"
                  type="text"
                  size="small"
                  @click="deleteMsg(scope.$index, scope.row)"
                >删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </section>
        <!-- dialog -->
        <el-dialog
          class="editDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
            <el-form-item label="管理设备" prop="rtu_name">
              <el-select placeholder="请选择管理设备" v-model="addEquipment.rtu_id" filterable @change="idChangeName">
                <el-option
                  v-for="item in RTU_id"
                  :key="item.id"
                  :value="item.id"
                  :label="item.deviceName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="节点号" prop="node">
              <el-input type="number" placeholder="请输入节点号" v-model="addEquipment.node"></el-input>
            </el-form-item>
            <el-form-item label="功能码" prop="code">
              <el-input placeholder="请输入功能码" v-model="addEquipment.code"></el-input>
            </el-form-item>
            <el-form-item label="轮询周期" prop="time">
              <el-input type="number" placeholder="请输入轮询周期" v-model="addEquipment.time">
                <template class="minute" slot="append">分钟</template>
              </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        rtu_id: [{ required: true, message: "请选择网关", trigger: "change" }],
        node: [{ required: true, message: "请输入节点号", trigger: "blur" }],
        code: [{ required: true, message: "请输入功能码", trigger: "blur" }],
        time: [{ required: true, message: "请输入轮询周期", trigger: "blur" }]
      },
      bLoading: true,
      tableData: [],
      tabName: "RTU",
      title: "",
      displayForm: false,
      loading: true,
      form_jsgl: {},
      showTable: true,
      other: {
        id: this.$route.params.id
      },
      items: [],
      addEquipment: {
        rtu_id: "",
        rtu_name: "",
        node: "",
        code: "",
        time: ""
      },
      title: "",
      status: "",
      RTU_id: [],
      row_id: ""
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "acqName",
          label: "网关"
        },
        {
          prop: "rtuName",
          label: "RTU名称"
        },
        {
          prop: "node",
          label: "节点号"
        },
        {
          prop: "code",
          label: "功能码"
        },
        {
          prop: "time",
          label: "轮询周期"
        }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    //rtu名称
    idChangeName(val) {
      //console.log(val,"val")
      let temp = this.RTU_id.find(it => val === it.id);
      //console.log(temp,"temp")
      if(temp) {
        this.addEquipment.rtu_name = temp.deviceName;
      }
    },
    //查询
    initdata() {
      this.$axiosget("operation/acqRelate/findByAcq", {
        params: {
          id: this.$route.params.id
        }
      }).then(res => {
        this.tableData = res.data.data;
        //console.log(res.data.data);
        this.bLoading = false;
      });
    },
    //新增
    toAddNew() {
      this.status = 1;
      this.displayForm = true;
      this.addEquipment = {
        rtu_id: "",
        rtu_name: "",
        node: "",
        code: "",
        time: ""
      };
      this.title = "新增RTU信息";
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //编辑
    toEdit(index, row) {
      this.status = 2;
      this.displayForm = true;
      this.title = "修改RTU信息";
      this.row_id = row.id;
      this.addEquipment.rtu_name = this.RTU_id.find(
        it => it.id === row.rtu_id
      ).deviceName;
      this.addEquipment.rtu_id = row.rtu_id;
      this.addEquipment.node = row.node;
      this.addEquipment.code = row.code;
      this.addEquipment.time = row.time;
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //确认
    submitForm() {
      this.$refs["addEquipment"].validate(valid => {
        if (valid) {
          if (this.status === 1) {
            this.$axiospost("operation/acqRelate/save", {
              acq_id: this.$route.params.id,
              rtu_id: this.addEquipment.rtu_id,
              code: this.addEquipment.code,
              node: this.addEquipment.node,
              time: this.addEquipment.time
            }).then(res => {
              this.displayForm = false;
              this.initdata();
              this.$message.success("新增成功！");
            });
          } else if (this.status === 2) {
            //console.log(this.addEquipment.rtu_id, this.addEquipment.rtu_name);
            this.$axiospost("operation/acqRelate/save", {
              id: this.row_id,
              acq_id: this.$route.params.id,
              rtu_id: this.addEquipment.rtu_id,
              code: this.addEquipment.code,
              node: this.addEquipment.node,
              time: this.addEquipment.time
            }).then(res => {
              this.displayForm = false;
              this.initdata();
              this.$message.success("修改成功！");
            });
          }
        }
      });
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm("是否删除该网关？", "删除操作", {
        cancelButton: "取消",
        confirmButton: "确定",
        type: "warning"
      }).then(() => {
        this.$axiosdelete("operation/acqRelate/delete", {
          params: {
            id: row.id
          }
        }).then(res => {
          this.$message.success("删除成功！");
          this.initdata();
        });
      });
    }
  },
  created() {
    //console.log(this.$route.params.id, "id");
    this.initdata();
    this.$axiosget("operation/device/findTypeDevices", {
      params: {
        device_kind: 1
      }
    }).then(res => {
      this.RTU_id = res.data.data;
    });
  }
};
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.w_breadcrumb {
  padding-left: 37px;
  position: relative;
  background: #0c111b;
  margin-top: -20px;
  .icondqwz {
    font-size: 15px;
    color: #4c6bc3;
    position: absolute;
    left: 22px;
    top: 1px;
  }
  .el-breadcrumb {
    height: 40px;
    line-height: 40px;
    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      float: left;
      display: inline-block;
      color: #35b9f7;
      cursor: pointer;
      transition: all 0.5s;
    }
    .el-breadcrumb__inner.is-link {
      color: #ccc;
      font-weight: 400;
      margin-left: 10px;
    }
    .el-breadcrumb__inner:hover {
      color: #35b9f7;
    }
  }
}
.el-input-group__append {
  border: 0;
  background: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/RTU.vue